"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _canteen = _interopRequireDefault(require("@/mixins/canteen"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _default2 = require("@/views/canteen/creatProduct/default");
var _canteen2 = require("@/api/canteen");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _default3 = require("@/views/scenic-spot/creatProduct/default");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _index.default
  },
  mixins: [_canteen.default],
  //此js存放商品的部分函数方法
  data: function data() {
    return {
      form: {},
      type: 0,
      title: '',
      labelarr: [],
      options: [],
      //菜品分类
      isEdit: false,
      proTypedialogVisible: false,
      //菜品新增弹窗
      rules: {
        image: [{
          required: true,
          message: '请上传菜品图片',
          trigger: 'change'
        }],
        flatPattern: [{
          required: true,
          message: '请输入展示图地址',
          trigger: 'blur'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入菜品名称',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入菜品简介',
          trigger: 'blur'
        }],
        keyword: [{
          required: true,
          message: '请输入关键词',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入菜品价格',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleRemove: function handleRemove(i) {
      this.form.sliderImages.splice(i, 1);
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    showEdit: function showEdit(row, type) {
      console.log('传进来的值', row, type);
      this.labelarr = [];
      this.getType();
      if (row) {
        this.title = '修改菜品';
        Object.assign(this.form, JSON.parse(JSON.stringify(row)));
        Object.assign(this.labelarr, JSON.parse(row.keyword));
        // sliderImage 格式处理
        if (typeof this.form.sliderImage === 'string' && this.form.sliderImage !== '') {
          if (this.form.sliderImage.startsWith('[')) {
            this.form.sliderImages = JSON.parse(this.form.sliderImage);
          } else {
            this.form.sliderImages = [this.form.sliderImage];
          }
        } else {
          this.form.sliderImages = [];
        }
        this.isEdit = type === 1 ? true : false;
        this.title = this.type === 1 ? '查看菜品' : '修改菜品';
      } else {
        this.title = '新增菜品';
        // 注意：上面已将 form 初始化为 defaultObj，因此不需要再次赋值
        this.isEdit = false;
        this.form = JSON.parse(JSON.stringify(_default3.defaultArea));
      }
    },
    // 获取菜品分类
    getType: function getType() {
      var _this = this;
      (0, _canteen2.listallSimple)({
        dictType: "dish:category"
      }).then(function (res) {
        console.log(res);
        if (res) {
          _this.options = res;
        }
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
      this.proTypedialogVisible = false;
      this.isEdit = false;
      this.form = JSON.parse(JSON.stringify(_default3.defaultArea));
    },
    //选择菜品类型确定
    // 保存
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.form.keyword = JSON.stringify(this.labelarr);
      this.form.sliderImage = JSON.stringify([this.form.image]);
      this.form.category = '川菜';
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          console.log(_this2.form);
          if (_this2.form.id) {
            (0, _canteen2.canteenUpdateApi)(_this2.form).then(function (res) {
              _this2.proTypedialogVisible = false;
              _this2.$emit('success');
              _this2.$message.success('修改成功');
            });
          } else {
            (0, _canteen2.canteenCreateApi)(_this2.form).then(function (res) {
              _this2.proTypedialogVisible = false;
              _this2.$emit('success');
              _this2.$message.success('新增成功');
            });
          }
        }
      });
    }
  }
};